import { render, staticRenderFns } from "./ExamTable.vue?vue&type=template&id=2f53371d&"
import script from "./ExamTable.vue?vue&type=script&lang=js&"
export * from "./ExamTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports